function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 10a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM8 16.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0zm7-.207V12h1v4.293a1 1 0 0 1-.293.707l-2.353 2.354-.708-.708L15 16.293z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.cc577410af5b35d5feb322048c1cb635.svg";
export { ForwardRef as ReactComponent };